import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import "./theme-button.css";
import { useTheme } from "../../../../common/hooks";
import { themeKeys } from "../../../../constants/themes";
import { BsFillSunFill, BsFillMoonFill } from "react-icons/bs";

export default function ThemeButton() {
  const { theme, setTheme, themeKey } = useTheme();
  const [isHover, setIsHover] = useState(false);
  const iconRef = useRef(null);

  const buttonStyle = {
    backgroundColor: theme.bgContrast + (isHover ? "FF" : "BB"),
    transform: isHover ? "scale(1.1)" : "scale(1)",
  };

  const icon =
    themeKey === themeKeys.DARK ? (
      <BsFillSunFill className="theme-icon" color="#FFDC00" size="60%" />
    ) : (
      <BsFillMoonFill className="theme-icon" color="white" size="50%" />
    );

  const onClick = async () => {
    await gsap.to(iconRef.current, {
      rotate: 40,
      transformOrigin: "20px 60px",
      duration: 0.3,
    });
    setTheme(themeKey === themeKeys.DARK ? themeKeys.LIGHT : themeKeys.DARK);
  };

  useEffect(() => {
    gsap.fromTo(
      iconRef.current,
      {
        rotate: -40,
        transformOrigin: "20px 60px",
      },
      {
        rotate: 0,
        transformOrigin: "20px 60px",
        duration: 0.3,
      }
    );
  }, [themeKey]);

  return (
    <button
      className="theme-button"
      style={buttonStyle}
      onClick={onClick}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="icon-container" ref={iconRef}>
        {icon}
      </div>
    </button>
  );
}
